/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IRegimen } from 'app/shared/model/regimen.model';
import { IRegimenDrug } from 'app/shared/model/regimen-drug.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';

export interface IRegimenAdverseEvent {
  id?: string;
  description?: string | null;
  monitoringParameters?: string | null;
  mitigationStrategies?: string | null;
  adverseEventInstructions?: string | null;
  severity?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  regimen?: IRegimen | null;
  drug?: IRegimenDrug | null;
  adverseEffectType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IRegimenAdverseEvent> = {
  active: false,
};
